import axios from "axios";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

const ACTION_TYPES = {
  FETCH_ALERTS_LIST: "applications/FETCH_ALERTS_LIST",
  SAVE_ALERT: "applications/SAVE_ALERT",
};

const initialState = {
  loading: false,
  alertsList: [],
};

export type ApplicationAlertsState = Readonly<typeof initialState>;

/**
 * ApplicationAlerts Reducer
 */
export default (state: ApplicationAlertsState = initialState, action): ApplicationAlertsState => {
  switch (action.type) {
    case PENDING(ACTION_TYPES.FETCH_ALERTS_LIST):
    case PENDING(ACTION_TYPES.SAVE_ALERT):
      return { ...state, loading: true };

    case FULFILLED(ACTION_TYPES.FETCH_ALERTS_LIST): {
      return {
        ...state,
        loading: false,
        alertsList: action.payload.data,
      };
    }

    case FULFILLED(ACTION_TYPES.SAVE_ALERT): {
      const newAlert = action.payload.data;
      return {
        ...state,
        loading: false,
        alertsList: [newAlert, ...state.alertsList],
      };
    }

    case REJECTED(ACTION_TYPES.FETCH_ALERTS_LIST):
    case REJECTED(ACTION_TYPES.SAVE_ALERT):
      return { ...state, loading: false };

    default:
      return state;
  }
};

/**
 * Action to fetch alerts list
 */
export const fetchAppAlertsList = (applicationId: string) => ({
  type: ACTION_TYPES.FETCH_ALERTS_LIST,
  meta: { applicationId },
  payload: axios.get(`/applications/${applicationId}/alerts`),
});

/**
 * Action to save a new or edit an existing alert
 */

export const saveApplicationAlert = (applicationId, alertData) => ({
  type: ACTION_TYPES.SAVE_ALERT,
  payload: axios.post(`applications/${applicationId}/alerts`, alertData, {
    headers: { "Content-Type": "application/json" },
  }),
});
